import React, { FunctionComponent, ReactNode } from 'react'
import useTranslation from '../../hooks/useTranslation'
import CarlineGroup from '../../entities/CarlineGroup'
import Carline from '../../entities/Carline'
import style from './carlineListView.css'
import SelectCarlineButton from '../select-carline-button'
import CarlineFilters from '../carline-filters'
import CarlineListViewPlaceholder from './CarlineListViewPlaceholder'
import CarlineImage from '../carline-image'
import CarlineGroupPlaceholderImage from '../../assets/media/car-silhouette56.svg'
import AttributeFilterResultPlaceholder from '../attribute-filters-placeholder'

export type Props = {
    carlineGroups: CarlineGroup[]
    isLoading: boolean
    carlineFiltersAreLoading: boolean
    backgroundImageType: string
}

const CarlineListView: FunctionComponent<Props> = (props) => {
    const { carlineGroups, isLoading, carlineFiltersAreLoading, backgroundImageType } = props
    const { t } = useTranslation()
    const filtersOrCarlinesAreLoading = isLoading || carlineFiltersAreLoading

    const createCarlineElement = (carline: Carline): ReactNode => {
        const {
            id,
            media,
            name,
            mbvModelYear,
        } = carline
        const imgElement = media?.length > 0 ? (
            <CarlineImage
                alt={name}
                media={media}
                className={style.image}
                width={100}
                height={42}
                backgroundColor="ffffff"
                backgroundImageType={backgroundImageType}
            />
        ) : <CarlineGroupPlaceholderImage className={style.placeholderImage} />

        return (
            <li key={id} className={style.listItem}>
                <SelectCarlineButton id={id} additionalStyle="list">
                    <div className={style.carlineContainer}>
                        {imgElement}
                        <span className={style.text}>
                            {name}
                            {' '}
                            {mbvModelYear}
                        </span>
                    </div>
                </SelectCarlineButton>
            </li>
        )
    }

    const availableCarlines = carlineGroups?.flatMap((carlineGroup) => carlineGroup.carlines)

    const groupElements = (carlineGroups.length === 0 && isLoading)
        ? <CarlineListViewPlaceholder />
        : carlineGroups.map((carlineGroup) => {
            const { id, name, carlines } = carlineGroup
            const listElements = carlines.map(createCarlineElement)

            if (carlines.length === 0) {
                return null
            }

            return (
                <section key={id} className={style.carlineGroupContainer}>
                    <h2>{name}</h2>
                    <ul className={style.list}>{listElements}</ul>
                </section>
            )
        })

    return (
        <div className={style.container}>
            <div>
                <h2>
                    {t('carlineFilter.title')}
                </h2>
                <CarlineFilters isLoading={filtersOrCarlinesAreLoading} layout="vertical" />
            </div>
            <div className={style.carlineGroupsWrapper}>
                <AttributeFilterResultPlaceholder hasAvailableResults={availableCarlines?.length !== 0}>
                    {groupElements}
                </AttributeFilterResultPlaceholder>
            </div>
        </div>
    )
}

export default CarlineListView
